module.exports = __webpack_public_path__ + "img/20_dice[13].8d38f2cb.png";